export const GET_CURRENT_BOARD = 'GET_CURRENT_BOARD';
export const SET_CURRENT_BOARD = 'SET_CURRENT_BOARD';
export const GET_SPECIAL_BOARD_POSITION = 'GET_SPECIAL_BOARD_POSITION';
